<template>
   <div class="process-todo">
    <div class="process-todo-header">
      <div class="process-todo-text">流程待办(6)</div>
      <div class="more">更多></div>
    </div>
    <div>
      <div class="process-todo-body">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待办事宜" name="first">
            <span slot="label">
              <el-badge :value="waitNum" :max="99" class="item">待办事宜</el-badge>
            </span>
            <el-row
              class="todo"
              v-for="(item, index) in todos"
              :key="index"
              :class="{ bg: isodd(index) }"
              @click="openFlow(item.id)"
            >
              <el-tag class="todo-tag">{{ item.title }}</el-tag>
              <span class="todo-span" @click="openFlow(item.id)">{{ item.depict }}</span>
              <span class="todo-time">
                <span class="item">{{ item.subject }}</span>
                <span class="item">{{ item.created | dateFormat}}</span>
              </span>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="已办事宜" name="second">
            <span slot="label">
              <el-badge :max="99" class="item">已办事宜</el-badge>
            </span>
            已办事宜
          </el-tab-pane>
          <el-tab-pane label="办结事宜" name="third">
            <span slot="label">
              <el-badge :max="99" class="item">办结事宜</el-badge>
            </span>
            办结事宜
          </el-tab-pane>
          <el-tab-pane label="抄送备案" name="fourth">
            <span slot="label">
              <el-badge :max="99" class="item">抄送备案</el-badge>
            </span>
            抄送备案
          </el-tab-pane>
          <el-tab-pane label="本人发起" name="five">
            <span slot="label">
              <el-badge :max="99" class="item">本人发起</el-badge>
            </span>
            本人发起
          </el-tab-pane>
          <el-tab-pane label="退回流程" name="six">
            <span slot="label">
              <el-badge :max="99" class="item">退回流程</el-badge>
            </span>
            退回流程
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>

</style>